// Whether an account's panel offers an address field, and whether that address is
// something Gundi actually needs. base_url lives on the integration record rather
// than in an action configuration, so this is the one place that decides.

import { isHiddenUrlDestinationType } from "../../destinations/isHiddenUrlDestinationType";
import { PROVIDER_TYPES_WITH_BASE_URL } from "../providerBaseUrl";

export type BaseUrlPolicy = {
    // Does the panel show an Endpoint section at all?
    show: boolean;
    // Is it allowed to be empty? Drives the " *" on the label and the "needs setup"
    // badge on the section.
    optional: boolean;
    // The technology works out its own address from its configuration, so a value
    // here is an override rather than an answer.
    derived: boolean;
};

export function baseUrlPolicy(input: {
    isProvider: boolean;
    techName?: string;
    techValue?: string;
    actions?: any[];
}): BaseUrlPolicy {
    const { isProvider, techName, techValue, actions } = input;
    const derived = isHiddenUrlDestinationType(techName || "");
    // Gundi cannot pull from a site it doesn't have the address of.
    const providerRequiresUrl = isProvider && PROVIDER_TYPES_WITH_BASE_URL.includes(techValue || "");
    // Any technology that can receive data carries an address when it is a
    // destination. Hiding that same field when the record happens to be the
    // route's provider left its address uneditable from the route.
    const canReceive = (actions || []).some((a: any) => a.type === "push");
    return {
        show: isProvider ? providerRequiresUrl || canReceive : true,
        // Optional on a provider Gundi doesn't need an address for: it is editable
        // there, but nothing is blocked without it.
        optional: derived || (isProvider && !providerRequiresUrl),
        derived,
    };
}
